module.exports = __webpack_public_path__ + "img/illustration-no-pending-tasks.9e1e9cfe.jpg";